<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="学生名称">
        <Input
          style="width:200px"
          placeholder="请输入名称关键字"
          v-model="searchCondition.nickname"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item label="手机号">
        <Input
          style="width:200px"
          placeholder="请输入手机号"
          v-model="searchCondition.phone"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/integral/logs"
        :search="searchCondition"
        selectType="none"
        method="get"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="record(row)" :disabled="row.status==1">积分记录-</Button>
          <Button
            type="text"
            size="small"
            @click="change(row)"
          >修改积分</Button>
        </template>
      </Grid>
    </div>
    <Modal
      class="refund-dlg"
      v-model="showSortModal"
      title="修改积分">
      <Form ref="searchForm" :label-width="70">
        <Form-item label="当前积分">
          <span>{{integral}}</span>
        </Form-item>
        <Form-item label="积分变化">
          <Input
            style="width:164px"
            placeholder="请输入积分变化"
            v-model="changeValue"
            type="number" /> 分
            &nbsp;&nbsp;
          <Icon type="ios-information-circle" color='#f90' size='18'></Icon>-1表示减去1积分
        </Form-item>
        <Form-item label="修改原因">
          <Input
            style="width:300px"
            :maxlength=16
            placeholder="请输入修改原因，最多16个字"
            v-model="reason"
            clearable/>
        </Form-item>
      </Form>
      <div slot="footer">
          <Button @click="confirmSort(0)" size="large" style="width: 100px">取消</Button>
          <Button type="primary" size="large" style="width: 100px" @click="confirmSort(1)">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "IntegralSort",
  data() {
    return {
      searchCondition: {
        nickname: "",
        phone: ""
      },
      showSortModal: false,
      columns: [
        {
          title: "学生名称",
          key: "nickname",
          minWidth: 200
        },
        {
          title: "手机号",
          key: "mobile",
          width: 200,
          align: "center"
        },
        {
          title: "积分值",
          key: "remaining_sum",
          width: 200,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center"
        }
      ],
      user_id: '',
      integral: '',
      changeValue: null,
      reason: ''
    };
  },
  methods: {
    search(flag) {
      if (flag == 0) {
        this.searchCondition.nickname = "";
        this.searchCondition.phone = "";
      }
      this.$refs.grid.searchRefresh();
    },
    change(item) {
      this.integral = item.remaining_sum;
      this.user_id = item.user_id;
      this.showSortModal = true;
    },
    /**
     * 跳转到某用户的积分记录
     */
    record(item) {
      this.$router.push({name: 'IntegralRecord',query: {user_id: item.user_id}})
    },
    /**
     * 修改积分
     */
    async confirmSort(flag) {
      if (!flag) {
        this.changeValue = null;
        this.reason = '';
        this.showSortModal = false;
      } else {
        if (!this.changeValue) {
          this.$Message.info("请输入积分变化");
          return;
        }
        if (!this.reason) {
          this.$Message.info("请输入修改原因");
          return;
        }
        // user_id  用户id
        // change_price  变更积分  整数是加 积分  负数 是减积分
        // remark  备注
        await this.$http.put("/api/integral/edit", {
          user_id: this.user_id,
          change_price: this.changeValue,
          remark: this.reason
        });
        this.$refs.grid.refresh();
        this.showSortModal = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.course-select {
  display: flex;
  justify-content: space-around;
}

.course-select-item {
  width: 176px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  height: 240px;
  color: #7f6697;
  margin: 8px;
  cursor: pointer;
  padding: 43px 28px;
  text-align: justify;
}

.course-select-title {
  color: black;
  font-size: 16px;
  text-align: center;
  position: relative;
  margin-bottom: 30px;
}

.course-select-type {
  position: absolute;
  color: red;
  font-size: 12px;
  top: -5px;
}

.cover-name {
  display: flex;
  align-items: center;
  .cover-wrap {
    width: 30px;
    height: 40px;
    margin-right: 15px;
  }
  .cover {
    width: 100%;
    height: 100%;
  }
  .integral {
    color: #f95959;
  }
}

.modal-sort {
  /deep/ {
    .ivu-modal-header {
      display: none;
    }
    .ivu-btn-primary {
      margin-left: 30px;
    }
  }
}
</style>